module.exports = __webpack_public_path__ + "static/media/portfolio.c17da767.png";